import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Chapters from "@/components/landing/Chapters";
import Services from "@/components/landing/Services";
import Gallery from "@/components/landing/Gallery";
import Testimonials from "@/components/landing/Testimonials";
import QuoteForm from "@/components/landing/QuoteForm";
import Footer from "@/components/landing/Footer";
import WhatsAppButton from "@/components/landing/WhatsAppButton";

export default function Landing() {
  const [content, setContent] = useState(null);
  const [gallery, setGallery] = useState([]);

  useEffect(() => {
    Promise.all([api.get("/content"), api.get("/gallery")])
      .then(([c, g]) => {
        setContent(c.data);
        setGallery(g.data);
      })
      .catch(() => setContent({}));
  }, []);

  if (!content) {
    return (
      <div className="min-h-screen bg-ink flex items-center justify-center" data-testid="landing-loading">
        <img src="/logo.png" alt="Perez Osorio Painting Services" className="w-40 rounded-2xl animate-pulse" />
      </div>
    );
  }

  return (
    <div className="bg-ink text-white min-h-screen" data-testid="landing-page">
      <Nav content={content} />
      <Hero content={content} />
      <Marquee text={content.marquee_text} />
      <Chapters content={content} />
      <Services content={content} />
      <Gallery items={gallery} />
      <Testimonials content={content} />
      <QuoteForm content={content} />
      <Footer content={content} />
      <WhatsAppButton phone={content.phone} />
    </div>
  );
}
